function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_312",
  "data-name": "Group 312",
  transform: "translate(-563 -656)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_83",
  "data-name": "Ellipse 83",
  cx: 13.5,
  cy: 13.5,
  r: 13.5,
  transform: "translate(563 656)",
  fill: "#ef6384"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_101",
  "data-name": "Path 101",
  d: "M2547.553,4817v5.67l6.78-2.233Z",
  transform: "translate(-1981 -4139)",
  fill: "#ef6384"
}));

var SvgBadge = function SvgBadge(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27.67,
    viewBox: "0 0 27 27.67",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBadge, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/badge.99a13c8b.svg";
export { ForwardRef as ReactComponent };